import React, { useState, useEffect } from 'react';
import DefaultLayout from '../../layouts/DefaultLayout';
import HeaderBG from '../../components/HeaderBG';
import SectionTitle from '../../components/SectionTitle';
import Drawer from './Drawer';
import { Container, Breadcrumb } from 'semantic-ui-react';
import Table from '../Remolques/Table';
import swal from 'sweetalert';
import feathers, { useAuth } from '../../services/feathers';
import Filters from './Filters';
import TopNavigation from './TopNavigation';


const Remolques = (props) => {
  const service = feathers.service('remolques');
  const auth = useAuth();

  let [query, setQuery] = useState({Placa : {$like:'%%'}, idOrganizacion: auth.user.client._id});
  const [isBusy, setIsBusy] = useState(false);
  const [selection, setSelection] = useState([]);
  const [data, setData] = useState([]);
  const [isSupport, setIsSupport] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [currentRemolque, setCurrentRemolque] = useState([]);
  const [remolque, setRemolque] = useState(null);
  

  useEffect(() => {
    const filter = () => {
      if(!query)
        query = {Placa : {$like:'%%'}, idOrganizacion: auth.user.client._id};
      getData();
    };

    filter();
  }, [query]);

  useEffect(() => {
    // console.debug('auth', JSON.stringify(auth, null, 2));
    const { isSupport } = (auth && auth.user) || {},
      client = (auth && auth.user && auth.user.client) || null,
      isInvalid = (!isSupport && !client && true) || false;

    setIsSupport(isSupport);
    setRemolque(client);
    setIsValid(!isInvalid);
  }, [auth.user]);
  
  const handleCreateClick = () => {
    const [clients, client] = auth.user.isSupport
      ? [[], {}]
      : [[{ ...auth.user.client }], { ...auth.user.client }];
    openDrawer({ clients, client });
  };

  const openDrawer = (remolque) => {
    remolque.idOrganizacion = auth.user.client._id
    setCurrentRemolque(remolque);
    setOpenPanel(true);
  };
  const handleClose = (isSuccess) => {
    setCurrentRemolque({});
    setOpenPanel(false);

    isSuccess && getData();
  };
  const handleSaveBulkData = async (results) => {
    let dataMap = results.validData.map(element=>{
      element.idOrganizacion = auth.user.client._id;
      return element
    })
    console.log(dataMap)
    let resultCreate = await service.create(dataMap);
    console.log('resultCreate', resultCreate);
    swal('Guardado', '¡Se ha guardado correctamente!', 'success');  
  }
  const getData = async () => {
    if (query) {
      let data = [],
        result = [];

      try {
        setIsBusy(true);
        setSelection([]);

        // console.debug('query', JSON.stringify(query, null, 2));
        if(query.Placa.idOrganizacion != ''){
          do {
            result = await service.find({
              query: {
                ...query,
                $skip: data.length,
              },
            });
            data = data.concat(result.data);
          } while (data.length !== result.total);
        }
      } catch (err) {
        console.error('Error', err);
        data = [];
        swal({
          title: 'Error',
          text: 'Failed get remolques',
          icon: 'error',
          buttons: {
            cancel: 'Close',
          },
        });
      } finally {
        setData(data);
        setIsBusy(false);
      }
    }
  };
  const handleEditClick = (remolque) => {
    openDrawer(remolque);
  };
  const handleDeleteClick = async (data) => {
    let confirmation = await swal('Do you want delete this item?', {
      buttons: ['No', 'Yes'],
    });

    if (confirmation) {
      try{
        await service.remove(data.id)
        swal('Borrado', '¡Se ha borrado correctamente!', 'success');
      }catch(exception){
        swal('Error', 'Dont delete transporte', 'error');
      }
      getData();
    }
  };

  const getClientName = () =>
    (auth && auth.user && auth.user.client && auth.user.client.name) || null;

  return (
     <>
      <DefaultLayout currentPath={props.match.path}
       globalActions={
        <TopNavigation
          isBusy={isBusy}
          onCreateClick={handleCreateClick}
          isValid={isValid}
          onSaveBulkData={handleSaveBulkData}
        />
      }
      >
        <HeaderBG />
        <Container className="fluid-95">
        <Breadcrumb
            icon="right angle"
            sections={[
              { key: getClientName(), content: getClientName(), link: false },
              // { key: 'Carta Porte', content: 'Carta Porte', link: false },
              {
                key: 'BillOfLadingMx',
                content: 'Remolques',
                active: true,
              },
            ]}
          />
          <Filters
            isBusy={isBusy}
            setQuery={setQuery}
            isValid={isValid}
            getData = {getData}
          />
          <Table data={data}
            selection={selection}
            setSelection={setSelection}
            isSupport={isSupport}
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}></Table>
        </Container>
      </DefaultLayout>
      {openPanel ? (
        <Drawer
          openPanel={openPanel}
          onClose={handleClose}
          currentRemolque={currentRemolque}
        ></Drawer>
      ) : null}
    </>
  );
  
};



export default Remolques;
